import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.189.004c.45 0 .899.05 1.338.152 1.11.265 1.478 1.72.981 2.538A8876 8876 0 0 0 9.774 22.223l-.384.654c-.256.451-.664.61-1.16.58-.497-.032-.772-.28-.958-.725-.404-.965-.834-1.922-1.26-2.88-.055-.117-.055-.206.01-.32q4.822-8.457 9.64-16.927c.179-.312.35-.623.532-.93C16.826.587 17.757 0 19.034.004zc0-.016-.004.015 0 0M5.414 18.494l-.668-1.503Q2.706 12.344.658 7.696c-.225-.51-.35-1.043-.23-1.608.133-.626.497-1.05 1.114-1.218a6.3 6.3 0 0 1 2.727-.132c.842.136 1.42.67 1.734 1.456.861 2.14 1.707 4.293 2.564 6.438a.41.41 0 0 1-.03.397 1099 1099 0 0 0-3.058 5.363z"
    }, null, -1)
  ]))]))
}
export default { render: render }